import React from "react";
import { Breadcrumb, Button, Card, Col, Divider, Form, Input, Layout, Row, Select, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { BLOCK_FORM_ENTER, POST_API, getEnv, getToken, titleWeb, verifyConfig } from "../../../services/api";

// CONTROLLER
import Page403 from '../../Controller/Page403';
import PageLoad from '../../Controller/PageLoad';

import conf from './conf.json';

class Screen extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _lista: [],
        _select: [],
        _screen: true,
        _dados: null,
        _search: false,
        total: 0,
        _params: window.location.href.split('/'),
        defaultValue: null
    }

    componentDidMount = async () => {
        titleWeb('Compras')
        await POST_API('/buy/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            this.setState({_dados: res.data})
            if (this.props.type === 'add') {
                this.setState({_screen: false})
            } else if (this.props.type === 'edit') {
                this.onView()
            }
        })
    }

    onView = async () => {
        POST_API('/buy/search.php', { token: getToken(), type: 'view', filter: JSON.stringify({ID: this.state._params[5]}) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data, _select: res.data.PRODUTOS})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        POST_API('/buy/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_loading: false}))
    }

    onSearch = (search) => {
        this.setState({_search: true})
        POST_API('/product_variation/search.php', { token: getToken(), type: 'list', pagination: JSON.stringify({current: 0, limit: 10}), search: search.target.value }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({_lista: res.data});
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_search: false}))
    }

    onAddProd = (v) => {
        this.setState({
            _select: [ ...this.state._select, v ],
            _lista: []
        })
    }

    onRemoveProd = (v) => {
        var temp = this.state._select;
        temp.splice(v, 1)
        this.setState({_select: temp})
    }

    render = () => {

        if (this.state._navigate) {
            return (<Navigate to={'/dashboard/buy'} />)
        }

        if (getToken() == null || !verifyConfig(conf.list)) {
            return (<Page403 />)
        }

        return (
            <Layout>
                <Layout.Content className={`${getEnv()}-container`}>
                    <Row gutter={[8,8]} align={'middle'}>
                        <Col span={18}>
                            <Breadcrumb>
                                <Breadcrumb.Item><Link to="/dashboard/buy">Compras</Link></Breadcrumb.Item>
                                <Breadcrumb.Item>{this.props.type === 'add' ? 'Adicionar' : 'Editar'}</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={'/dashboard/buy'}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                        { this.state._screen ? <PageLoad /> : (
                            <Col span={24}>
                                <Form onKeyDown={BLOCK_FORM_ENTER} layout="vertical" className={`${getEnv()}-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Form.Item hidden name="ID">
                                        <Input />
                                    </Form.Item>
                                    <Row gutter={[16,0]}>
                                        <Col xs={24} md={12}>
                                            <Form.Item label="Fornecedor" name="PROVIDER_ID" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select allowClear>
                                                    <Select.Option disabled value="0">Selecione...</Select.Option>
                                                    { this.state._dados.FILTER_PROVIDER.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <Form.Item label="Data Compra" name="DATE_BUY" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input type="date" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={12} md={4}>
                                            <Form.Item label="Data Vencimento" name="DATE_DUE" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input type="date" />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={4}>
                                            <Form.Item label="Número de Parcelas" name="INSTALLMENTS" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input type="number" min={0} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}><Divider>Produtos</Divider></Col>
                                        { this.state._select.map((v, i) => (
                                            <Col key={i} md={24} xs={24} style={{marginBottom: 16}}>
                                                <Card hoverable size="small" title={'#'+v.BARCODE}>
                                                    <Row gutter={[8,0]} align={'bottom'}>
                                                        <Col xs={24} md={8}>
                                                            <Typography style={{marginBottom: 8}}>Nome</Typography>
                                                            <Input value={v.PRODUCT_NAME} readOnly style={{marginBottom: 24}} />
                                                        </Col>
                                                        <Col xs={12} md={3}>
                                                            <Typography style={{marginBottom: 8}}>Cor</Typography>
                                                            <Input value={v.COLOR} readOnly style={{marginBottom: 24}} />
                                                        </Col>
                                                        <Col xs={12} md={3}>
                                                            <Typography style={{marginBottom: 8}}>Tamanho</Typography>
                                                            <Input value={v.SIZE} readOnly style={{marginBottom: 24}} />
                                                        </Col>
                                                        <Col xs={14} md={3}>
                                                            <Typography style={{marginBottom: 8}}>Valor</Typography>
                                                            <Input addonBefore="R$" value={v.PRICE_BUY} readOnly style={{marginBottom: 24}} />
                                                        </Col>
                                                        <Col xs={10} md={4}>
                                                            <Form.Item label="Quantidade" name={`PRODUCT_${v.ID}_QTD`} rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                                <Input type="number" />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xs={24} md={3}>
                                                            <Button shape="round" onClick={() => this.onRemoveProd(i)} block type="primary" className="table__btn_delete" style={{marginBottom: 24}}>Deletar</Button>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        ))}
                                        <Col xs={24} md={24}>
                                            <Input allowClear onChange={this.onSearch} style={{marginBottom: 25}} placeholder="Pesquisar produtos por nome, categoria, cor, tamanho, material, ID ou código de barras." />
                                        </Col>
                                        {this.state._lista.map((v, i) => (
                                            <Col key={i} md={24} xs={24} style={{marginBottom: 16}}>
                                                <Card onClick={() => this.onAddProd(v)} hoverable size="small" title={'#'+v.BARCODE}>
                                                    <Row gutter={[8,8]}>
                                                        <Col xs={24} md={12}>
                                                            <Typography>Nome</Typography>
                                                            <Input value={v.PRODUCT_NAME} readOnly />
                                                        </Col>
                                                        <Col xs={24} md={6}>
                                                            <Typography>Categoria</Typography>
                                                            <Input value={v.CATEGORY_NAME} readOnly />
                                                        </Col>
                                                        <Col xs={12} md={3}>
                                                            <Typography>Cor</Typography>
                                                            <Input value={v.COLOR} readOnly />
                                                        </Col>
                                                        <Col xs={12} md={3}>
                                                            <Typography>Tamanho</Typography>
                                                            <Input value={v.SIZE} readOnly />
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                        ))}
                                        <Col xs={24} md={24}>
                                            <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" className="float-right">Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        ) }
                    </Row>
                </Layout.Content>
            </Layout>
        )

    }

}

export default Screen;